import { render, staticRenderFns } from "./toolbar-days.vue?vue&type=template&id=63478f10"
import script from "./toolbar-days.vue?vue&type=script&lang=js"
export * from "./toolbar-days.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports